import { render } from "./LbrxSubMenuButton.vue?vue&type=template&id=76c1ca16&scoped=true"
import script from "./LbrxSubMenuButton.vue?vue&type=script&lang=js"
export * from "./LbrxSubMenuButton.vue?vue&type=script&lang=js"

import "./LbrxSubMenuButton.vue?vue&type=style&index=0&id=76c1ca16&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c1ca16"]])

export default __exports__